import React from "react";
import BaseTypography, { BaseTypographyType } from "../base";

// Base heading type without level and size props
export type HeadingType = Omit<BaseTypographyType, "type" | "level" | "size">;

// Mega heading component
export const Mega = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level="mega"
    />
  );
};

// H1 heading component
export const H1 = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level={1}
    />
  );
};

// H2 heading component
export const H2 = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level={2}
    />
  );
};

// H3 heading component
export const H3 = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level={3}
    />
  );
};

// H4 heading component
export const H4 = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level={4}
    />
  );
};

// H5 heading component
export const H5 = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level={5}
    />
  );
};

// H6 heading component
export const H6 = (props: HeadingType) => {
  return (
    <BaseTypography
      {...props}
      type="heading"
      level={6}
    />
  );
};

// Export types for external use
export type MegaType = HeadingType;
export type H1Type = HeadingType;
export type H2Type = HeadingType;
export type H3Type = HeadingType;
export type H4Type = HeadingType;
export type H5Type = HeadingType;
export type H6Type = HeadingType; 